<div class="system-page">
  @if (loading) {
    <div class="system-page__group">
      <p>Loading...</p>
    </div>
  }

  @if (error) {
    <div class="system-page__group">
      <p>Could not load status information.</p>
    </div>
  }

  @if (!loading && !error) {
    <div class="system-page__group">
      <h3 class="subheading">API Health</h3>
      <div class="module">
        <span class="status-badge" [class.status-badge--up]="healthStatus === 'UP'" [class.status-badge--down]="healthStatus !== 'UP'">
          {{ healthStatus }}
        </span>
      </div>
    </div>
    <div class="system-page__group">
      <h3 class="subheading">DB Connection Pool</h3>
      @if (dbPool) {
        <table class="status-table">
          <thead>
            <tr>
              <th>Acquired</th>
              <th>Idle</th>
              <th>Allocated</th>
              <th>Pending</th>
              <th>Max allocated</th>
              <th>Max pending</th>
            </tr>
          </thead>
          <tbody>
            <tr [class.status-table__row--warning]="dbPool.pending > 0">
              <td>{{ dbPool.acquired }}</td>
              <td>{{ dbPool.idle }}</td>
              <td>{{ dbPool.allocated }}</td>
              <td>{{ dbPool.pending }}</td>
              <td>{{ dbPool.maxAllocated }}</td>
              <td>{{ dbPool.maxPending }}</td>
            </tr>
          </tbody>
        </table>
      } @else {
        <p>Not available.</p>
      }
    </div>
    <div class="system-page__group">
      <h3 class="subheading">Queue Status</h3>
      <table class="status-table">
        <thead>
          <tr>
            <th>Queue</th>
            <th>Depth</th>
            <th>In flight</th>
            <th>DLQ</th>
          </tr>
        </thead>
        <tbody>
          @for (queue of queues; track queue) {
            <tr [class.status-table__row--warning]="queue.stats.dlqCount > 0">
              <td>{{ queue.name }}</td>
              <td>{{ queue.stats.queueDepth }}</td>
              <td>{{ queue.stats.inFlightCount }}</td>
              <td>{{ queue.stats.dlqCount }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="system-page__group">
      <h3 class="subheading">Buffered Gateway Status</h3>
      <table class="status-table">
        <thead>
          <tr>
            <th>Gateway</th>
            <th>Buffered</th>
            <th>Active groups</th>
            <th>Oldest event (s)</th>
            <th>Last flush</th>
            <th>Flush errors</th>
          </tr>
        </thead>
        <tbody>
          @for (gw of gateways; track gw) {
            <tr [class.status-table__row--warning]="gw.stats.totalFlushErrors > 0">
              <td>{{ gw.name }}</td>
              <td>{{ gw.stats.totalBuffered }}</td>
              <td>{{ gw.stats.activeGroups }}</td>
              <td>{{ gw.stats.oldestEventAgeSeconds }}</td>
              <td>{{ gw.stats.lastFlushAt ?? '—' }}</td>
              <td>{{ gw.stats.totalFlushErrors }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
